import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

import EmailSubscribeInput from 'Components/Input/EmailSubscribeInput';

import 'Components/InfoBar/Usp/SmallUspBar/SmallUspBar.scss';

const EmailSubscribeBar = ({ mobileEnabled, appearsOn }) =>
  <div className="small-usp-bar">
    <div className="EmailSubscribeBar container">
      <div className="EmailSubscribeBar__copy">
        <FontAwesomeIcon icon={faPaperPlane} />
        {mobileEnabled ?
          <FormattedMessage
            id="email-subscribe-bar.mobile-message"
            defaultMessage="Sign-up for Fanatical's Newsletter!"
          /> :
          <FormattedMessage
            id="email-subscribe-bar.desktop-message"
            defaultMessage="Get great game deals! Sign-up for the Fanatical Newsletter now!"
          />
        }
      </div>
      <EmailSubscribeInput mobileEnabled={mobileEnabled} appearsOn={appearsOn} />
    </div>
  </div>;

EmailSubscribeBar.propTypes = {
  mobileEnabled: PropTypes.bool,
};

EmailSubscribeBar.defaultProps = {
  mobileEnabled: false,
};

export default EmailSubscribeBar;
